// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"400":"c03ca680e0140e9e","489":"4d31c523c7db5094","883":"5b5917e03012b28b"}[chunkId] + ".js";
};